import ArticlePage from "@/pages/article/ArticlePage";
import { allArticles } from "@/mocks/articles";

export default function PriceGuideArticle() {
  return <ArticlePage article={allArticles["allchinabuy-spreadsheet-price-guide"]} />;
}